module.exports = __webpack_public_path__ + "static/media/MuseoSlab-500.ea2901bc.eot";